import React from "react";
import ReactMarkdown from "react-markdown";
import changelog_md from "../../../CHANGELOG.md";
import { ReactComponent as Logo } from "../logo.svg";

import HOC from "../../../hoc";

import "./changelog-page.scss";
import "github-markdown-css";
import { connect } from "react-redux";
import setTheme from "../../../utils/setTheme";

const { withLocalization } = HOC;

class ChangeLogPage extends React.Component {
    state = {
        markdown: ""
    };
    componentDidMount() {
        fetch(changelog_md)
            .then(res => res.text())
            .then(markdown => this.setState({ markdown }))
            .catch();
    }
    render() {
        const { loc, theme } = this.props;
        const { markdown } = this.state;
        setTheme(theme);
        return (
            <div className="changelog-page">
                <div className="changelog-page__logo-container">
                    <Logo />
                </div>
                <h1 className="changelog-page__header">{loc("pages.changelog")}</h1>

                <div className="changelog-page__content markdown-body">
                    <ReactMarkdown>{markdown}</ReactMarkdown>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        theme: state.reportApp.app.settings.theme
    };
};

export default connect(mapStateToProps)(withLocalization(ChangeLogPage));
